import { render, staticRenderFns } from "./WebTraffic.vue?vue&type=template&id=2ec0b8c6&scoped=true"
import script from "./WebTraffic.vue?vue&type=script&lang=js"
export * from "./WebTraffic.vue?vue&type=script&lang=js"
import style0 from "./WebTraffic.vue?vue&type=style&index=0&id=2ec0b8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec0b8c6",
  null
  
)

export default component.exports